let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("39nwk")).then(() => parcelRequire('lrFlX'));